export enum SelectorScreenMenuType {
  Style = 'Style',
  Gang = 'Gang',
  TopLevel = 'TopLevel',
  Orientation = 'Orientation',
  Sockets = 'Sockets',
  OutdoorType = 'OutdoorType',
  WiserType = 'WiserType',
}

export const WiserMenus = new Set<SelectorScreenMenuType>([SelectorScreenMenuType.TopLevel, SelectorScreenMenuType.WiserType])

export const SwitchMenuOptions = new Set<SelectorScreenMenuType>([
  SelectorScreenMenuType.TopLevel,
  SelectorScreenMenuType.Style,
  SelectorScreenMenuType.Gang,
  SelectorScreenMenuType.Orientation,
])

export const SocketMenus = new Set<SelectorScreenMenuType>([
  SelectorScreenMenuType.TopLevel,
  SelectorScreenMenuType.Style,
  SelectorScreenMenuType.Orientation,
  SelectorScreenMenuType.Sockets,
])

export const OtherMenuItems = new Set<SelectorScreenMenuType>([
  SelectorScreenMenuType.TopLevel,
  SelectorScreenMenuType.Style,
  SelectorScreenMenuType.Orientation,
])

export const OutdoorMenuItems = new Set<SelectorScreenMenuType>([
  SelectorScreenMenuType.TopLevel,
  SelectorScreenMenuType.OutdoorType,
])

export default SelectorScreenMenuType